export default function contactFormHandler() {
	const btnContact = document.querySelector('#btnContact');
	const contactForm = document.querySelector('#contactForm');

	if (btnContact) {
		btnContact.addEventListener('click', function () {
			contactForm.classList.toggle('show');
			btnContact.classList.toggle('form-open');

			setTimeout(function () {
				contactForm.classList.toggle('visible');
			}, 300);
		});
	}
}
